import React from 'react';
import Accordian from '../../../atoms/Accordian/Accordian';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
const TermOfUseQuestions = props => {
  const { questionList = [], headerData: { title } = {}, isMobile } = props;
  const onClickHandler = e => {
    const accordian = e.target.parentElement.parentElement.parentElement;
    accordian.classList.contains('terms-accordian-open')
      ? accordian.classList.remove('terms-accordian-open')
      : accordian.classList.add('terms-accordian-open');
  };
  return (
    <div>
      {questionList.map((item, index) => {
        return (
          <div
            className='terms-accordian'
            id={isMobile && questionList[0].question === item.question ? 'removeLine' : ''}
          >
            <Accordian
              data-testId='acordian-handle'
              header={title === 'Terms of Use' ? `${item.question}` : `${index + 1}. ${item.question}`}
              onClickHandler={onClickHandler}
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: documentToHtmlString(item.answer),
                }}
                className='terms-accordian-answer'
              />
            </Accordian>
          </div>
        );
      })}
    </div>
  );
};

export default TermOfUseQuestions;
